import { Injectable, inject } from '@angular/core';
import { PermissionNodeInput } from '@control-tower/features/collaborators/models/permission-node.input';
import { GraphqlClientService } from '@core/services/graphql-client.service';
import { PermissionNode } from '@shared/components/permissions-tree/models/permission-node.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  GET_PERMISSION_TEMPLATE_BY_SERVICE_TYPES_QUERY,
  GET_PERMISSION_TREE_QUERY,
  GET_USER_PERMISSION_PRESET_QUERY,
  SAVE_COLLABORATOR_PERMISSION_TREE_MUTATION,
  SAVE_USER_PERMISSION_PRESET_MUTATION,
} from '../queries/permission-tree.queries';
@Injectable({
  providedIn: 'root',
})
export class PermissionsTreeService {
  private readonly graphqlClient = inject(GraphqlClientService);

  getPermissionTemplateByServiceTypes(serviceTypes: string[], controlTowerId: string): Observable<PermissionNode[]> {
    return this.graphqlClient
      .query<
        { getPermissionTemplateByServiceTypes: PermissionNode[] },
        { serviceTypes: string[]; controlTowerId: string }
      >(GET_PERMISSION_TEMPLATE_BY_SERVICE_TYPES_QUERY, {
        serviceTypes,
        controlTowerId,
      })
      .pipe(map(result => result.getPermissionTemplateByServiceTypes || []));
  }

  getPermissionTree(collaboratorId: string, controlTowerId: string): Observable<PermissionNode[]> {
    return this.graphqlClient
      .query<
        { getPermissionTree: PermissionNode[] },
        { collaboratorId: string; controlTowerId: string }
      >(GET_PERMISSION_TREE_QUERY, { collaboratorId, controlTowerId })
      .pipe(map(result => result.getPermissionTree || []));
  }

  saveCollaboratorPermissionTree(collaboratorId: string, newTree: PermissionNodeInput[]): Observable<string[]> {
    return this.graphqlClient
      .mutation<
        { saveCollaboratorPermissionTree: string[] },
        { input: { collaboratorId: string; newTree: PermissionNodeInput[] } }
      >(SAVE_COLLABORATOR_PERMISSION_TREE_MUTATION, {
        input: { collaboratorId, newTree },
      })
      .pipe(map(result => result.saveCollaboratorPermissionTree || []));
  }

  getUserPermissionPreset(inviteeIdentifier: string, controlTowerId: string): Observable<PermissionNode[]> {
    return this.graphqlClient
      .query<
        { getUserPermissionPreset: PermissionNode[] },
        { inviteeIdentifier: string; controlTowerId: string }
      >(GET_USER_PERMISSION_PRESET_QUERY, { inviteeIdentifier, controlTowerId })
      .pipe(map(result => result.getUserPermissionPreset || []));
  }

  saveUserPermissionPreset(
    inviteeIdentifier: string,
    inviteeType: string,
    permissionNodes: PermissionNodeInput[],
  ): Observable<any> {
    return this.graphqlClient
      .mutation<
        { saveUserPermissionPreset: any },
        { input: { inviteeIdentifier: string; inviteeType: string; permissionNodes: PermissionNodeInput[] } }
      >(SAVE_USER_PERMISSION_PRESET_MUTATION, {
        input: { inviteeIdentifier, inviteeType, permissionNodes },
      })
      .pipe(map(result => result.saveUserPermissionPreset));
  }
}
